module.exports = __webpack_public_path__ + "static/media/slide-1.89ae4129.jpg";